import React from "react";
import RechargeFormPage from "./RechargeFormPage";

function RechargeAddPage() {
  return <RechargeFormPage />;
}

export default RechargeAddPage;
